import { render, staticRenderFns } from "./PanelBanners.vue?vue&type=template&id=69bbc4f0&scoped=true&"
import script from "./PanelBanners.vue?vue&type=script&lang=js&"
export * from "./PanelBanners.vue?vue&type=script&lang=js&"
import style0 from "./PanelBanners.vue?vue&type=style&index=0&id=69bbc4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bbc4f0",
  null
  
)

export default component.exports